import type { RouteObject } from 'react-router-dom';
import { RequirePermission } from '../auth/guards';
import { ReportPage } from '../reports/ReportPage';
import { DealerWalletPage } from './DealerWalletPage';

/**
 * Customer Service entries that are not about one customer: the Payment Search Tool (PC339,
 * a screen of the reports engine, which checks the code itself) and the Dealer Wallet (PC544).
 */
export const billingRoutes: RouteObject[] = [
  { path: 'customers/payment-search', element: <ReportPage reportKey="payment-search" /> },
  {
    path: 'dealer-wallet',
    element: (
      <RequirePermission code="PC544">
        <DealerWalletPage />
      </RequirePermission>
    ),
  },
];
